import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import { useEffect, useState } from "react";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { FaExclamationTriangle } from "react-icons/fa";
import useCommon from "hooks/useCommon";

const DeleteGuestDialog = ({ open, onClose, onConfirm, guest }) => {
  const { STORE } = useCommon();

  const { deleteGuestLoading } = STORE((state) => state.guests);

  const [step, setStep] = useState(1);

  const handleClose = () => {
    if (deleteGuestLoading) return;

    setStep(1);
    onClose?.();
  };

  const handleNext = () => {
    if (deleteGuestLoading) return;
    setStep(2);
  };

  const handleDelete = () => {
    if (deleteGuestLoading) return;

    onConfirm?.(guest);
  };

  useEffect(() => {
    if (open) setStep(1);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown" || deleteGuestLoading) return;

        handleClose();
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <VuiBox textAlign="center" py={0}>
          {step === 2 && (
            <VuiBox mb={1} display="flex" justifyContent="center">
              <VuiBox
                width={60}
                height={60}
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  background: "rgba(255, 77, 79, 0.15)",
                  border: "1px solid rgba(255, 77, 79, 0.4)",
                }}
              >
                <FaExclamationTriangle size={24} color="#ff4d4f" />
              </VuiBox>
            </VuiBox>
          )}

          <VuiTypography variant="h6" mb={1}>
            {step === 1 ? "Are you sure?" : "Permanent Deletion"}
          </VuiTypography>

          <VuiTypography variant="body2" mb={3} sx={{ fontSize: "14px" }}>
            {step === 1
              ? `Do you want to delete the guest ${guest?.name || "this guest"}?`
              : "This will permanently delete all guest data including stays, notes, preferences, and history. This action cannot be undone."}
          </VuiTypography>

          <VuiBox display="flex" justifyContent="center" gap={1.5}>
            <VuiButton
              variant="outlined"
              color="primary"
              size="small"
              disabled={deleteGuestLoading}
              onClick={handleClose}
            >
              Cancel
            </VuiButton>

            {step === 1 ? (
              <VuiButton variant="gradient" color="error" size="small" onClick={handleNext}>
                Yes, Continue
              </VuiButton>
            ) : (
              <VuiButton
                variant="gradient"
                color="error"
                size="small"
                disabled={deleteGuestLoading}
                onClick={handleDelete}
                sx={{ color: "#fff" }}
              >
                {deleteGuestLoading ? (
                  <VuiBox display="flex" alignItems="center" gap={1} sx={{ color: "#fff" }}>
                    <CircularProgress
                      size={12}
                      sx={{
                        color: "#fff",
                      }}
                    />
                    Deleting...
                  </VuiBox>
                ) : (
                  "Delete Permanently"
                )}
              </VuiButton>
            )}
          </VuiBox>
        </VuiBox>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteGuestDialog;
